import { useState } from 'react';
import { api, type Sessao } from '../api';
import { useRota } from '../rota';
import { useAgir } from '../../../compartilhado/useAgir';

/** Dados, regulamento e a porta de saída — o mínimo digno da §17. */
export function Perfil({ sessao, aoSair }: { sessao: Sessao; aoSair: () => void }) {
  const { ir } = useRota();
  const [regulamento, setRegulamento] = useState<string | null>(null);
  /*
   * Chaves separadas porque as duas ações são independentes: buscar o
   * regulamento não pode travar o "sair", nem o contrário. O rótulo troca
   * enquanto roda — botão desabilitado e mudo é indistinguível de botão morto,
   * e o regulamento chega pela rede.
   */
  const { rodando, agir } = useAgir();

  async function abrirRegulamento() {
    await agir('regulamento', async () => {
      const r = await api
        .regulamento()
        .catch(() => ({ texto: 'não consegui carregar o regulamento' }));
      setRegulamento(r.texto);
    });
  }

  async function sair() {
    await agir('sair', async () => {
      await api.sair().catch(() => {});
      aoSair();
    });
  }

  return (
    <div className="tela pf">
      <h1 className="titulo-tela">perfil</h1>

      <div className="pf-cartao">
        <div className="pf-linha">
          <span className="pf-rotulo">telefone</span>
          <span className="pf-valor">{sessao.telefone}</span>
        </div>
        {sessao.nome && (
          <div className="pf-linha">
            <span className="pf-rotulo">nome</span>
            <span className="pf-valor">{sessao.nome}</span>
          </div>
        )}
        <div className="pf-linha">
          <span className="pf-rotulo">programa</span>
          <span className="pf-valor">{sessao.nomeLoja}</span>
        </div>
      </div>

      <button className="pf-item" onClick={() => ir('/extrato')}>
        extrato completo
      </button>
      <button
        className="pf-item"
        disabled={rodando('regulamento')}
        onClick={() => void abrirRegulamento()}
      >
        {rodando('regulamento') ? 'abrindo o regulamento…' : 'regulamento do programa'}
      </button>
      <button className="pf-item sair" disabled={rodando('sair')} onClick={() => void sair()}>
        {rodando('sair') ? 'saindo…' : 'sair'}
      </button>

      {regulamento !== null && (
        <div className="veu" onClick={() => setRegulamento(null)}>
          <div className="folha" onClick={(e) => e.stopPropagation()}>
            <div className="folha-pega" />
            <div className="folha-titulo">regulamento</div>
            <div className="pf-regulamento">{regulamento}</div>
            <button className="botao-vazado" onClick={() => setRegulamento(null)}>
              Fechar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
